import { useContext } from 'react'
import { ScPCAPortalContext } from 'contexts/ScPCAPortalContext'

export const useScPCAPortal = () => useContext(ScPCAPortalContext)
